import { DevicePark, MetmastSensor } from "app/shared/models/data-studio.model";

export interface ISeries {
  assetId: string;
  assetIdY?: string;
  chartData: number[][];
  chartDataX?: number[][];
  chartDataY?: number[][];
  chartTypeName: string;
  color: string;
  dashStyle?: string;
  device: string;
  deviceName: string; // Added missing type string
  deviceNameY?: string;
  deviceType: DeviceType;
  deviceTypeY?: DeviceType;
  deviceY?: string;
  granularity: string;
  id: string;
  marker?: { symbol: string };
  newItem: boolean;
  numberOfSeries?: number;
  parkDisplayName?: string;
  parkId?: string;
  parkName: string;
  queryData: string;
  signal: string;
  signalName: string;
  signalNameY?: string;
  signalY?: string;
  step?: boolean;
  type: string;
  unit: string;
  unitY?: string;
  visible: boolean;
  yAxis: number;
  yAxisMax?: number;
  yAxisMin?: number;
}

export interface IDataStudioQuery {
  id: string;
  name: string;
  period: string;
  granularity: string;
  startTs: number;
  endTs: number;
  series: ISeries[];
}

export type IDataStudioPark = {
  name: string;
  fe_name: string;
  data30sAvailable: boolean;
  devices: Partial<IDataStudioDevice>[]
  signalList?: Array<IDataStudioSignal>;
  selected?: boolean;
  _id?: string;
}

export const DEVICE_TYPES = {
  PARK: 'park',
  TURBINE: 'turbine',
  CONTROL_SYSTEM: 'controlSystem',
  METMAST: 'metmastSensor'
} as const;
export type DeviceType = typeof DEVICE_TYPES[keyof typeof DEVICE_TYPES];
export type DataStudioParksList = Omit<IDataStudioPark, 'devices'> & {
  turbines: IDataStudioDevice[],
  controlSystem?: Partial<IDataStudioDevice>[],
  metmasts?: Partial<MetMastDataAnalysis>[]
};

export type MetMastDataAnalysis = Partial<DevicePark> & {
  sensorsList: Partial<MetmastSensor>[]
}

export interface IDataStudioDevice {
  _id: string;
  name: string;
  type: string;
  code: string;
  deviceType?: DeviceType;
  serialNav?: number;
  queryData?: string;
  parkId?: string;
  parkName?: string;
  signalsList?: Array<IDataStudioSignal>;
  selected?: boolean;
}

export interface IDataStudioSignal {
  name?: string;
  displayName?: string;
  displayShortName?: string;
  signalGroupType?: string;
  description?: string;
  unit?: string;
  deviceType?: DeviceType;
  selected?: boolean;
}

export interface IYAxis {
  labels: {
    format?: string;
    style: {
      color: string;
    }
  },
  title: {
    text: string;
    style: {
      color: string;
    }
  },
  opposite?: boolean,
  min?: number,
  max?: number,
  index?: number,
  tickPositions?: any,
  showEmpty?: boolean
}

export interface IQueriesList {
  id?: string;
  title: string;
  assets?: string;
  period: DataAnalysisPeriod;
  startTs: number;
  endTs: number;
  series: ISerie[];
}

export interface ISerie {
  turbineId: string;
  parkId?: string;
  signal: string;
  signalName: string;
  signalUnit: string;
  granularity: string;
  visible: boolean;
  aggregation: DataAnalysisAggregation;
  colorHex: string;
  graphType: string;
}

enum DataAnalysisPeriod {
  'Day',
  'Week',
  'Month',
  'Year'
}

enum DataAnalysisAggregation {
  MIN,
  MAX,
  AVG,
  SUM,
}
